(function() {
    'use strict';

    angular
        .module('pwc.controllers')
        .controller('PasswordRecoverController', PasswordRecoverController);

    PasswordRecoverController.$inject = ['API', '$log'];

    function PasswordRecoverController(API, $log) {

        /* jshint validthis: true */
        var self = this;

        self.state = {
            success: false,
            message: '',
            sending: false
        };

        self.email = null;

        self.submit = submit;

        /** begin methods */

        function submit(){

            self.state.sending = true;

            API.recoverPassword(self.email).then(function(response) {

                $log.debug('API register response', response);

                self.state.success = true;

            }).catch(function(response){

                $log.error(response);

                self.state.message = response.data.error;

            }).finally(function(){

                self.state.sending = false;

            });
        }

    }

})();
